import { buildBaseProps, buildScoresData } from "../../helpers";
const scoreKeys = [
    { header: "DefaultPoints", team1Key: "homeScore", team2Key: "awayScore", translatable: true, gamePart: "" }
];
export const buildDefaultLiveMobileProps = (event, config) => {
    const scoresData = buildScoresData(event, scoreKeys, config);
    return Object.assign(Object.assign({}, buildBaseProps(event, config.dict)), { team1Scores: scoresData.team1Scores, team2Scores: scoresData.team2Scores, header: scoresData.headers, liveGameState: event.liveGameState });
};
//# sourceMappingURL=buildDefaultLiveMobileProps.js.map